import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    base: "bg-[#cfb3f3] px-4 py-2 w-full gap-1 flex sticky top-[var(--header-template-2-height)] lg:top-[var(--header-template-1-height)] left-0 right-0 z-50 max-h-10",
    content: "flex justify-between items-center w-full max-w-component-max-w-xl mx-auto",
    step: "h-6 bg-black/10 w-fit p-1.5 flex justify-center items-center relative text-label-md rounded-full min-w-[fit-content] origin-left text-black stroke-black",
    stepProgress: "bg-[#8032E4]/40 h-full absolute left-0 rounded-full",
    shippingCostBadge: "bg-black text-secondary font-semibold text-[10px] px-0.5 py-0.5 absolute -top-3 left-1 z-10 -rotate-3",
    freeShipping: "text-label-md text-center w-full p-1.5"
  },
  variants: {
    placedIn: {
      productPage: {
        base: "py-4 px-4 mt-4 rounded-lg bg-[#e8dbf8] max-h-none"
      },
      header: {
        base: ""
      }
    }
  }
}), p = e({
  slots: {
    wrapper: "",
    container: "",
    barometer: "",
    steps: "",
    step: "",
    stepLabel: "",
    stepActive: "",
    stepCompleted: "",
    stepCompletedIcon: "",
    freeTier: "",
    freeMessage: "",
    progressBar: "",
    currentShippingCost: ""
  },
  variants: {
    background: {
      purple: {
        wrapper: ""
      },
      none: {
        wrapper: ""
      }
    },
    align: {
      center: {
        wrapper: ""
      },
      left: {
        wrapper: ""
      }
    }
  }
});
export {
  r as shippingBarometerBouncyStepsBlueprint,
  p as shippingBarometerTemplate1Blueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
